export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";
// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";

export const headers = [
  { label: "Situação", key: "situacao", isVisible: true }, // As seen in the image's first header
  { label: "Data", key: "data", isVisible: true },
  { label: "Tipo", key: "tipo", isVisible: true },
  { label: "Tipo Janela", key: "tipoJanela", isVisible: true },
  { label: "Código Janela", key: "codigoJanela", isVisible: true },
  { label: "Janela", key: "janela", isVisible: true },
  { label: "Previsão", key: "previsao", isVisible: true },
  { label: "Contrato", key: "contrato", isVisible: true },
  { label: "Demanda", key: "demanda", isVisible: true },
];

export const mockData = [
  {
    situacao: "Livre", 
    data: "2024-06-01",
    tipo: "Entrada",
    tipoJanela: "Normal",
    codigoJanela: "JN-001",
    janela: "08:00 - 10:00",
    previsao: "2024-06-01T09:00:00Z",
    contrato: "C-12345",
    demanda: 100,
  },
  {
    situacao: "Ocupado", // Another example status
    data: "2024-06-02",
    tipo: "Saída",
    tipoJanela: "Especial",
    codigoJanela: "JN-002",
    janela: "10:30 - 12:30",
    previsao: "2024-06-02T11:30:00Z",
    contrato: "C-67890",
    demanda: 200,
  },
  {
    situacao: "Em Processamento", // Another example status
    data: "2024-06-03",
    tipo: "Transferência",
    tipoJanela: "Padrão",
    codigoJanela: "JN-003",
    janela: "14:00 - 16:00",
    previsao: "2024-06-03T15:00:00Z",
    contrato: "C-11223",
    demanda: 50,
  },
  {
    situacao: "Divergente", // Another example status
    data: "2024-06-04",
    tipo: "Devolução",
    tipoJanela: "Urgente",
    codigoJanela: "JN-004",
    janela: "09:00 - 11:00",
    previsao: "2024-06-04T09:45:00Z",
    contrato: "C-44556",
    demanda: 75,
  },
  {
    situacao: "Armazenado", // Another example status
    data: "2024-06-05",
    tipo: "Entrada",
    tipoJanela: "Normal",
    codigoJanela: "JN-005",
    janela: "13:00 - 15:00",
    previsao: "2024-06-05T14:00:00Z",
    contrato: "C-77889",
    demanda: 120,
  },
];